import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../config/apiconfig';
import { useSettings } from './SettingsContext'; // For token & error handling

const ReportTypeContext = createContext();

export const useReportTypes = () => useContext(ReportTypeContext);

export const ReportTypeProvider = ({ children }) => {
  const [reportTypes, setReportTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { setError: setSettingsError } = useSettings(); // optional global error handler

useEffect(() => {
  const token = localStorage.getItem("token");

  //console.log("Token:", token);

  if (!token) {
    //console.log("No token found");
    return;
  }

  const fetchReportTypes = async () => {
    try {
      //console.log("Calling report-types API...");

      setLoading(true);

      const res = await axios.get(`${BASE_URL}/report-types`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      //console.log("API Response:", res.data);

      if (res.data.status == 200) {
        const types = res.data.data.map(item => ({
          value: item.id,
          label: item.title,
          description: item.description,
        }));

        //console.log("Mapped Types:", types);

        setReportTypes(types);
      }
    } catch (err) {
      //console.log(err);
    } finally {
      setLoading(false);
    }
  };

  fetchReportTypes();
}, []);


  return (
    <ReportTypeContext.Provider value={{ reportTypes, loading, error }}>
      {children}
    </ReportTypeContext.Provider>
  );
};
